<!-- <h1 mat-dialog-title>Add New User</h1>
<div mat-dialog-content>
  <mat-form-field>
    <mat-label>First Name</mat-label>
    <input matInput [(ngModel)]="firstName">
  </mat-form-field>
  <mat-form-field>
    <mat-label>Email</mat-label>
    <input matInput [(ngModel)]="email">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="{firstName: firstName, email: email}" cdkFocusInitial>Submit</button>
</div> -->


    <!-- <h1 mat-dialog-title>Add New User</h1>
    <div mat-dialog-content>
      <mat-form-field>
        <mat-label>First Name</mat-label>
        <input matInput [(ngModel)]="firstName">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="email">
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button [mat-dialog-close]="{firstName: firstName, email: email}" cdkFocusInitial>Submit</button>
    </div> -->


    <!-- <h1 mat-dialog-title>Add New User</h1>
    <div mat-dialog-content>
        <mat-form-field>
            <mat-label>First Name</mat-label>
            <input matInput [(ngModel)]="firstName">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput [(ngModel)]="email">
        </mat-form-field>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">Cancel</button>
        <button mat-button [mat-dialog-close]="{firstName: firstName, email: email}" cdkFocusInitial>Submit</button>
    </div> -->
    <div class="requestdaialogcontent">
    <div class="dialog-shell">
      <div class="dialog-topbar">
        <div>

          <h1 mat-dialog-title>Initiate onboarding request</h1>
        </div>
        <button type="button" class="dialog-close" aria-label="Close dialog" (click)="onNoClick()">
          <span>&times;</span>
        </button>
      </div>
  
   <!--
// v0 by Vercel.
// https://v0.dev/t/clSbB44yMnj
-->

<div class="formdiv">
    <form class="reqform" (ngSubmit)="handleClick()">
      <div class="form-grid">
        <div class="field-block">
          <label class="field-label" for="firstName">
            First Name
          </label>
          <input
            [(ngModel)]="firstName"
            name="firstName"
            class="custominput"
            type="text"
            id="firstName"
            placeholder="Enter first name"
          />
        </div>

        <div class="field-block">
          <label class="field-label" for="email">
            Email
          </label>
          <input
            [(ngModel)]="email"
            name="email"
            class="custominput"
            type="email"
            id="email"
            placeholder="Enter email"
          />
        </div>

        <div class="field-block field-block-full" *ngIf="staticOptions.length">
          <label class="field-label" for="staticField">
            {{ staticFieldLabel }}
          </label>
          <div class="select-wrap">
            <select
              [(ngModel)]="selectedStaticValue"
              name="selectedStaticValue"
              class="custominput customselect"
              id="staticField"
              [disabled]="staticLoading"
            >
              <option value="">Select {{ staticFieldLabel }}</option>
              <option *ngFor="let option of staticOptions" [ngValue]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="dialog-actions">
        <button type="button" class="secondary-btn" (click)="onNoClick()">
          Cancel
        </button>
        <button type="submit" class="onboardingreqbtn" [disabled]="!firstName || !email || (staticOptions.length > 0 && !selectedStaticValue)">
          Submit Request
        </button>
      </div>
    </form>
  </div>
</div>
</div>